import usePendingState from '../../Hooks/usePendingState';
import { useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useNotification } from '../../Contexts/NotificationContext';

export const ConfirmModal = ({ closeModal, type, confirm, icon, onSuccess }) => {
    const [pending, setPending, pendingRef] = usePendingState();
    const { setNotification } = useNotification();

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !pendingRef.current) {
                closeModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [closeModal, pendingRef]);

    const messages = {
        logOut: {
            title: 'Log Out?',
            call: 'Tem certeza que deseja sair?',
            message: 'Pressione [Não] se quiser continuar o trabalho. Pressione [Sim] para sair do usuário atual.',
            success: 'Logout concluído',
            error: 'Não foi possível efetuar o logout',
            method: 'POST',
        },
        delete: {
            title: 'Excluir?',
            call: 'Tem certeza que deseja excluir?',
            message: 'Pressione [Não] se quiser continuar o trabalho. Pressione [Sim] para confirmar a exclusão.',
            success: 'Registro excluído com sucesso',
            error: 'Não foi possível excluir o registro',
            method: 'DELETE',
        },
        deleteUser: {
            title: 'Excluir usuário?',
            call: 'Tem certeza que deseja excluir?',
            message: 'Pressione [Não] se quiser continuar o trabalho. Pressione [Sim] para confirmar a exclusão.',
            success: 'Usuário excluído com sucesso',
            error: 'Não foi possível excluir o usuário',
            method: 'DELETE',
        },
    };

    const handleSubmit = async () => {
        if (pendingRef.current) return;
        setPending(true);
        try {
            const response = await fetch(`${baseUrl + confirm}`, {
                method: messages[type]['method'],
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(messages[type]['error']);
            }

            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: messages[type]['success'],
                    show: true,
                });
                await onSuccess?.();
            }

            closeModal();
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setPending(false);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-[99999] sort-ignore">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { if (!pendingRef.current) closeModal(); }}></div>
            <div className="animate-fade-in-down [animation-duration:_0.1s] rounded-sm border border-stroke bg-white max-w-xl px-8 py-12 text-center shadow-md relative">
                <FontAwesomeIcon
                    icon={icon}
                    className={`text-2xl text-red-500 bg-red-100 py-4 rounded-full mb-6${icon.iconName === 'xmark' ? ' px-5' : ' px-4'}`}
                />
                <h2 className="text-2xl font-bold mb-2">{messages[type]['title']}</h2>
                <p className="text-slate-500 mb-10">
                    {messages[type]['call']}
                    <br />
                    {messages[type]['message']}
                </p>
                <div className="mx-auto flex gap-x-6 max-w-96">
                    <div className="w-full">
                        <button
                            disabled={pending}
                            className="w-full bg-secondary bg-opacity-75 border border-secondary text-white py-2 px-4 rounded mr-2 hover:bg-opacity-100"
                            onClick={() => { if (!pendingRef.current) closeModal(); }}
                        >
                            Não
                        </button>
                    </div>

                    <div className="w-full">
                        <button
                            disabled={pending}
                            className="block w-full bg-red-500 border border-red-500 text-white py-2 px-4 rounded mr-2 hover:bg-red-600"
                            onClick={handleSubmit}
                        >
                            {pending ? 'Processando...' : 'Sim'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
